<template>
    <div>
        <steps :currentStep="currentStep" @switchStep="switchStep"></steps>

        <div class="new-product">
            <div class="my-4">
                <div v-if="step === currentStep">
                    <form @submit.prevent.stop="switchStep" novalidate>
                        <div class="d-flex justify-content-end align-items-center border-bottom-light my-4 p-4">
                            <button class="btn blue wider mr-3" :disabled="$v.form.$invalid" @click="prevStep" v-if="getSelectedItem != null"><i class="ico-arrow-left fs-normal ml-2"></i> Back</button>
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button class="btn green wider mr-3" :disabled="$v.form.$invalid" @click="readyToSave" v-if="getSelectedItem !== null">Save</button>
                            <button class="btn blue wider" :disabled="$v.form.$invalid" @click="nextStep">Next <i class="ico-arrow-right fs-normal ml-2"></i></button>
                        </div>

                        <div class="px-4">
                            <div class="panel shaded">
                                <h5 class="mt-5">Prices</h5>

                                <div v-if="taxes" class="form-group row">
                                    <div class="col-sm-3">
                                        <label class="full">Tax</label>

                                        <v-select
                                            v-model="selectedTax"
                                            :options="taxes"
                                            label="description"
                                            placeholder="- Select tax -"
                                            @input="updateTax">
                                        </v-select>
                                    </div>

                                    <div class="col-sm-3 d-flex align-items-center">
                                        <label class="full mt-3 normal">
                                            <checkbox v-model="form.includeTaxes">
                                                Price include taxes.
                                            </checkbox>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group row mt-5" v-for="(price, index) in form.prices">
                                    <div class="col-sm-5">
                                        <label class="full">Product pricing <span class="brand">*</span></label>

                                        <v-select
                                            v-if="types"
                                            v-model="price.selectedType"
                                            :options="types"
                                            label="description"
                                            placeholder="- Select type -"
                                            @input="updateType(price)">
                                        </v-select>
                                    </div>

                                    <div class="col-sm-3" v-if="isPerson">
                                        <label class="full">&nbsp;</label>

                                        <v-select
                                            v-if="audienceTypes"
                                            v-model="price.selectedAudienceType"
                                            :options="audienceTypes"
                                            label="description"
                                            placeholder="- Select person -"
                                            @input="updateAudienceType(price)">
                                        </v-select>
                                    </div>

                                    <div class="col-sm-2" :class="{ error: $v.form.prices.$each[index].value.$error }">
                                        <label class="full">
                                            &nbsp;
                                            <div class="d-flex">
                                                <input class="glued-right" type="number" v-model="price.value" @input="$v.form.prices.$each[index].value.$touch">
                                                <div class="glued-left">€</div>
                                            </div>
                                        </label>

                                        <div v-if="$v.form.prices.$each[index].value.$error" class="messages">
                                            <span v-if="!$v.form.prices.$each[index].value.required">Price is required.</span>
                                            <span v-if="!$v.form.prices.$each[index].value.withParams">Price must be a number.</span>
                                        </div>
                                    </div>

                                    <div v-if="index > 0" class="col-sm-2">
                                        <label class="full">&nbsp;</label>
                                        <i class="ico-delete largest medium align-items-bottom pointer" @click="deleteRow(index)"></i>
                                    </div>
                                </div>

                                <div v-if="hasAddRow" class="add d-flex align-items-center pointer fs-small bold" @click="addRow">
                                    <i class="ico-add fs-smallest add-circle color-1"></i> Add new price
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-end align-items-center border-top-light my-4 p-4">
                            <button class="btn blue wider mr-3" :disabled="$v.form.$invalid" @click="prevStep" v-if="getSelectedItem != null"><i class="ico-arrow-left fs-normal ml-2"></i> Back</button>
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button class="btn green wider mr-3" :disabled="$v.form.$invalid" @click="readyToSave" v-if="getSelectedItem !== null">Save</button>
                            <button class="btn blue wider" :disabled="$v.form.$invalid" @click="nextStep">Next <i class="ico-arrow-right fs-normal ml-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Steps from './ProductSteps'
    import extendedVSelect from '@/extends/vue-select'
    import { required, withParams } from 'vuelidate/lib/validators'

    export default {
        props: {
            currentStep: Number,
        },
        data: function() {
            return {
                step: 3,
                isPerson: false,
                hasAddRow: false,
                form: {
                    prices: [],
                    tax: null,
                },
                selectedTax: null,
            }
        },
        validations: {
            form: {
                prices: {
                    $each: {
                        value: {
                            required,
                            withParams: ((value) => {
                                return value >= 0;
                            }),
                        }
                    }
                },
            }
        },
        created: function() {
            this.form = JSON.parse(JSON.stringify(this.getClonedItem));

            if (this.form.prices === undefined) {
                this.form.prices = [];
            }

            // VAT
            if (this.form.tax) {
                this.selectedTax = this.taxes.find(item => item.id === this.form.tax);
            }
            else {
                this.selectedTax = this.taxes[0];
                this.form.tax = this.taxes[0].id;
            }
        },
        asyncComputed: {
            async audienceTypes() {
                try {
                    let response = await axios.get('/api/settings/GetAudienceTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects

                        if (this.form.prices && this.form.prices.length > 0) {
                            this.form.prices.forEach(p => {
                                p.selectedAudienceType = response.data.find(item => item.id === p.audienceType);
                            });
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },
            async types() {
                try {
                    let response = await axios.get('/api/settings/GetComponentExtraPriceTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects or initialize first price

                        if (this.form.prices !== undefined && this.form.prices.length > 0) {
                            this.form.prices.forEach(p => {
                                p.selectedType = response.data.find(item => item.id === p.type);
                            });
                        }
                        else {
                            this.form.prices.push({
                                id: 0,
                                value: 0,
                                selectedType: response.data[0],
                                type: response.data[0].id,
                                selectedAudienceType: null,
                                audienceType: null
                            });
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
                'getClonedItem',
                'getVatTypes'
            ]),
            taxes: function () {
                return this.getVatTypes
            }
        },
        methods: {
            updateTax: function() {
                this.form.tax = this.selectedTax.id || null;
            },
            updateType: function(price) {
                let index = this.form.prices.indexOf(price);

                if (index > -1) {
                    this.form.prices[index].type = price.selectedType.id;

                    if (this.form.prices[index].type == 2) {
                        this.isPerson = true;
                        this.hasAddRow = true;
                    }
                    else {
                        this.isPerson = false;
                        this.hasAddRow = false;

                        if (this.form.prices.length < 1) {
                            this.form.prices = [
                                {
                                    id: 0,
                                    value: '',
                                    selectedType: this.types[0],
                                    type: this.types[0].id,
                                    selectedAudienceType: null,
                                    audienceType: null
                                }
                            ];
                        }
                    }
                    this.formatValue();
                }
            },
            updateAudienceType: function(price) {
                let index = this.form.prices.indexOf(price);

                if (index > -1) {
                    this.form.prices[index].audienceType = price.selectedAudienceType.id;
                }
            },
            addRow: function() {
                this.form.prices.push(this.createEmptyRow());
                this.formatValue();
            },
            createEmptyRow: function() {
                return {
                    id: 0,
                    value: '',
                    selectedType: this.types[1],
                    type: this.types[1].id,
                    selectedAudienceType: null,
                    audienceType: null,
                    genderPriceDependencies: []
                };
            },
            deleteRow: function(row) {
                this.form.prices.splice(row, 1);
            },
            formatValue: function() {
                this.form.prices.forEach(function(item) {
                    item.value = parseFloat(item.value).toFixed(2);
                });
            },
            cancel: function() {
                this.$emit('cancelling');
            },
            switchStep: function(step) {
                this.$emit('goToStep', { invalid: this.$v.form.invalid, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            prevStep: function(step) {
                this.$emit('goToStep', { invalid: this.$v.form.invalid, form: this.form, step: (step !== undefined && !isNaN(step) ) ? step : (this.currentStep - 1) });
            },
            nextStep: function(step) {
                this.$emit('goToStep', { invalid: this.$v.form.invalid, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            readyToSave: function() {
                this.$emit('readyToSave', { invalid: false, form: this.form });
            },
        },
        components: {
            vSelect: extendedVSelect,
            Steps,
        }
    }
</script>



// WEBPACK FOOTER //
// ProductPrices.vue?5ab0b3d1